module.exports = __webpack_public_path__ + "static/media/omar.86a8f6dd.png";